export default __webpack_public_path__ + "static/media/welcome-female.f5abfbb5.png";